module.exports = "/_next/static/images/petsitter.com-8b756b0aad9a1fa77d12002807774cfa.svg";